__turbopack_context__.v({
  "avatar": "avatar-module-scss-module__5yrKyG__avatar",
  "avatar--size-tiny": "avatar-module-scss-module__5yrKyG__avatar--size-tiny",
});
